import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  name: 'lineChart',
  mixins: [reactiveProp],
  data() {
    return {
      gradient: null,
      gradient2: null
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
      this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
      
      this.gradient.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
      this.gradient.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
      this.gradient.addColorStop(1, 'rgba(0, 231, 255, 0)');

      this.gradient2.addColorStop(0, 'rgba(255, 235, 60, 0.5)')
      this.gradient2.addColorStop(0.5, 'rgba(255, 235, 60, 0.25)');
      this.gradient2.addColorStop(1, 'rgba(255, 235, 60, 0)');

      this.renderChart(this.chartData !== null ? {
        labels: this.chartData.labels,
        datasets: this.chartData.data3 !== null ? [
          {
            label: this.chartData.label1,
            borderColor: '#05CBE1',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#05CBE1',
            backgroundColor: this.gradient,
            data: this.chartData.data1
          }, {
            label: this.chartData.label2,
            borderColor: '#ea9200',
            pointBackgroundColor: 'white',
            pointBorderColor: '#ea9200',
            borderWidth: 1,
            backgroundColor: this.gradient2,
            data: this.chartData.data2
          }, {
            label: this.chartData.label3,
            borderColor: '#FC2525',
            pointBackgroundColor: 'white',
            pointBorderColor: '#FC2525',
            borderWidth: 1,
            backgroundColor: 'transparent',
            data: this.chartData.data3
          }
        ] : [
            {
              label: this.chartData.label1,
              borderColor: '#05CBE1',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#05CBE1',
              backgroundColor: this.gradient,
              data: this.chartData.data1
            }, {
              label: this.chartData.label2,
              borderColor: '#ea9200',
              pointBackgroundColor: 'white',
              pointBorderColor: '#ea9200',
              borderWidth: 1,
              backgroundColor: this.gradient2,
              data: this.chartData.data2
            }
        ]
      } : null, { responsive: true, maintainAspectRatio: false })
    }
  }
}